/* eslint-disable prettier/prettier */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import axios from "axios";
import "./registerServiceWorker";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bulma-extensions/dist/css/bulma-extensions.min.css";
import "vue-loading-overlay/dist/vue-loading.css";

import VeeValidate from "vee-validate";
import createAuthRefreshInterceptor from "axios-auth-refresh";

Vue.use(Buefy, {
  defaultIconPack: "fas"
});

Vue.use(VeeValidate);

Vue.config.productionTip = false;

// dev mode
if (Vue.config.devtools) {
  // local server
  axios.defaults.baseURL = "https://localhost:44342/";
} else {
  if (process.env.VUE_APP_ANOTHER_VARIABLE === "ANSI") {
    // crm.anynetworksystems.com
    axios.defaults.baseURL = "https://api-crm.anynetworksystems.com/";
  } else {
    axios.defaults.baseURL = "https://api-crm.adaptivenets.com/";
  }
}

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

const tokens = {
  token: localStorage.getItem("token"),
  refreshToken: localStorage.getItem("refreshToken")
};
// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest =>
  axios
    .post(`api/token/refresh`, tokens)
    .then(response => {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      failedRequest.response.config.headers["Authentication"] =
        "Bearer " + response.data.token;
      return Promise.resolve();
    })
    .catch(error => {
      if (error.response) {
        alert(error.response.data);
      }
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");

      router.go({
        name: "Login"
      });
    });

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic);

function getAccessToken() {
  return localStorage.getItem("token");
}

axios.interceptors.request.use(request => {
  request.headers["Authorization"] = `Bearer ${getAccessToken()}`;
  return request;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
